import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TAny, TIdName } from "@app/lib/models/common.type";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { Observable } from "rxjs";
import { IAssignCourt, IAvaiableJudgeParams, ICaseItem, ICasePartyParams, ICaseSearchRequestBody, ICaseTrailCourt, ICaseTrailCourtRequestBody, ICourtDivisionParams, ICourtSessionPanel, ICourtSessionPanelParams, ICourtUnitType, IJudge, IJudgeStat, IJudgeStatBody, IPagination, ISearchRequestParams } from "../models/case-assignment.model";
import { CloseTaskData, TaskTypeNames } from "../models/close-task.model";

@Injectable({
    providedIn: 'root'
})
export class CloseTaskService extends BaseHttpService {

    constructor(http: HttpClient, appConfig: AppConfiguration) {
        super(http, appConfig);
    }

    /**
     * Search Case By case information
     * @param reqBody 
     * @param queryParams 
     * @returns 
     */
    searchCase(reqBody: TAny): Observable<IResponse<CloseTaskData[]>> {
        return this.post<IResponse<CloseTaskData[]>, TAny>('tasks/get-tasks.htm', reqBody,);
    }
    getTaskType(): Observable<IResponse<TaskTypeNames[]>> {
        return this.get<IResponse<TaskTypeNames[]>>('tasktypes/fetch/task-types-lov.htm');
    }
    onCloseTask(reqBody: TAny): Observable<IResponse<TAny>> {
        return this.post<IResponse<TAny>,TAny>('tasks/close/pending-task.htm',reqBody);
    }

}